module.exports = __webpack_public_path__ + "static/media/Informe-Carvajal-Empaques-2024.11ddbf76.pdf";